import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=01369086&"
import script from "./Protocol.vue?vue&type=script&lang=js&"
export * from "./Protocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports